import { render, staticRenderFns } from "./wapTab.vue?vue&type=template&id=7e7759d0&scoped=true"
import script from "./wapTab.vue?vue&type=script&lang=js"
export * from "./wapTab.vue?vue&type=script&lang=js"
import style0 from "./wapTab.vue?vue&type=style&index=0&id=7e7759d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7759d0",
  null
  
)

export default component.exports